import { BaseModifier } from './BaseModifier';
import { ExpandTextModifier, ExpandLineModifier } from './ExpandModifiers';
import { MoveLineModifier, MoveTextModifier } from './MoveModifiers';

export class ModifiersFactory {
  private static getMoveModifier(
    Data: Editor.Data.API,
    granularity: Editor.Selection.ModifierGranularity,
    direction: Editor.Selection.ModifierDirection,
    incrementOffset?: number,
  ): BaseModifier {
    switch (granularity) {
      case 'character':
      case 'word':
        return new MoveTextModifier(Data, granularity, direction, incrementOffset);
      case 'line':
        return new MoveLineModifier(Data, direction);
    }
  }

  private static getExpandModifier(
    Data: Editor.Data.API,
    granularity: Editor.Selection.ModifierGranularity,
    direction: Editor.Selection.ModifierDirection,
    incrementOffset?: number,
  ): BaseModifier {
    switch (granularity) {
      case 'character':
      case 'word':
        return new ExpandTextModifier(Data, granularity, direction, incrementOffset);
      case 'line':
        return new ExpandLineModifier(Data, direction);
    }
  }

  static getModifier(
    Data: Editor.Data.API,
    type: Editor.Selection.ModifierType,
    granularity: Editor.Selection.ModifierGranularity,
    direction: Editor.Selection.ModifierDirection,
    incrementOffset?: number,
  ): BaseModifier {
    switch (type) {
      case 'move':
        return this.getMoveModifier(Data, granularity, direction, incrementOffset);
      case 'expand':
        return this.getExpandModifier(Data, granularity, direction, incrementOffset);
    }
  }
}
